import React, { useCallback } from 'react';
import { TbChevronLeft, TbChevronRight } from 'react-icons/tb';

const PaginationFront = ({ pagination, paginationLinks, prevPage, nextPage, page }) => {
    if (!pagination || !paginationLinks) return null;

    const handlePrevPage = useCallback(() => {
        if (pagination.prev_page_url) prevPage(pagination.prev_page_url);
    }, [pagination.prev_page_url, prevPage]);

    const handleNextPage = useCallback(() => {
        if (pagination.next_page_url) nextPage(pagination.next_page_url);
    }, [pagination.next_page_url, nextPage]);

    const isPrevPageDisabled = !pagination.prev_page_url;
    const isNextPageDisabled = !pagination.next_page_url;

    return (
        <>
            <style>{`
                .page-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 9999px;
                    font-size: 0.875rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: box-shadow 0.25s ease, transform 0.2s ease, color 0.2s ease;
                    white-space: nowrap;
                    background: #ffffff;
                    color: #313041;
                    border: none;
                    position: relative;
                }
                .page-btn::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    border-radius: 9999px;
                    padding: 1.5px;
                    background: linear-gradient(135deg, #313041, #E8604C);
                    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                    -webkit-mask-composite: xor;
                    mask-composite: exclude;
                    pointer-events: none;
                }
                .page-btn:hover {
                    color: #E8604C;
                    transform: translateY(-1px);
                }
                .page-btn-active {
                    background: linear-gradient(135deg, #E8604C 0%, #313041 100%);
                    color: #ffffff !important;
                    box-shadow: 0 4px 14px rgba(232,96,76,0.35);
                    cursor: not-allowed;
                }
                .page-btn-active::before {
                    display: none;
                }
                .page-btn-active:hover {
                    transform: none;
                    box-shadow: 0 4px 14px rgba(232,96,76,0.35);
                }
                .page-btn-arrow {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 9999px;
                    border: none;
                    background: linear-gradient(135deg, #E8604C08 0%, #31304108 100%);
                    color: #E8604C;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: box-shadow 0.25s ease, transform 0.2s ease, background 0.2s ease;
                    position: relative;
                }
                .page-btn-arrow::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    border-radius: 9999px;
                    padding: 1.5px;
                    background: linear-gradient(135deg, #E8604C, #313041);
                    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                    -webkit-mask-composite: xor;
                    mask-composite: exclude;
                    pointer-events: none;
                }
                .page-btn-arrow:hover {
                    background: linear-gradient(135deg, #E8604C 0%, #313041 100%);
                    color: #ffffff;
                    box-shadow: 0 4px 14px rgba(232,96,76,0.35);
                    transform: translateY(-1px);
                }
            `}</style>

            <ul className="inline-flex items-center gap-2">
                {!isPrevPageDisabled && (
                    <li>
                        <button type="button" onClick={handlePrevPage} className="page-btn-arrow">
                            <span className="sr-only">Previous</span>
                            <TbChevronLeft />
                        </button>
                    </li>
                )}

                {paginationLinks.map((pageItem, index) => {
                    if (pageItem.label.includes('&laquo; Previous') || pageItem.label.includes('Next &raquo;')) return null;
                    return (
                        <li key={index}>
                            <button
                                type="button"
                                onClick={() => !pageItem.active && page(pageItem.label)}
                                disabled={pageItem.active}
                                className={`page-btn ${pageItem.active ? 'page-btn-active' : ''}`}
                            >
                                {pageItem.label}
                            </button>
                        </li>
                    );
                })}

                {!isNextPageDisabled && (
                    <li>
                        <button type="button" onClick={handleNextPage} className="page-btn-arrow">
                            <span className="sr-only">Next</span>
                            <TbChevronRight />
                        </button>
                    </li>
                )}
            </ul>
        </>
    );
};

export default PaginationFront;